import styled from 'styled-components';
import { colors } from "../../utils/colors";

export const Button = styled.button`
    background-color: ${colors.CREAM};
    color: ${colors.BLUE};
    font-family: 'Dancing Script', cursive;
    border: none;
    padding: 5px;
    border-radius: 25px;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: .2s ease-in;
    width: 100px;
    z-index: 10;
    text-transform: uppercase;

    &:hover{
        cursor: pointer;
        color: ${colors.WHITE};
    }
`;
